import { getUserPermissions } from '../utils/helpers';
import { TabsGeneric } from '@rabbit/elements/shared-components';
import InformationTab from '../components/molecules/account-management/InformationTab';
import LegalTab from '../components/molecules/account-management/LegalTab';
import UsersTab from '../components/molecules/account-management/UsersTab';
import { useTranslation } from 'react-i18next';
import { Address } from '@rabbit/data/types';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { Navigate } from 'react-router-dom';
import { SAGE_ROUTE_NAME } from '@rabbit/config/enums';
import { Permissions } from '@rabbit/data/types';
import { AppContext } from '@rabbit/app-context';
import IWarrantyAdmin from '../components/molecules/account-management/iWarrantyAdmin';
import { IWARRANTY_SUPERADMIN_EMAIL } from '../utils/consts';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AccountManagementViewProps {}

export function MyOrgnizationView(props: AccountManagementViewProps) {
  const { t } = useTranslation();
  const { tenantInfo } = useContext(AppContext);
  const userContext = useContext(UserContext);
  const tenantLink = t('tenantLink');
  const userPermissions = getUserPermissions(tenantLink, userContext);
  if (!userPermissions?.includes(Permissions.Owner))
    return <Navigate to={SAGE_ROUTE_NAME.MANAGE_ACCOUNT} />;

  const isSuperAdmin = Boolean(
    userContext?.accessToken?.admin ||
      userContext?.user?.email?.toLowerCase() === IWARRANTY_SUPERADMIN_EMAIL
  );

  const getProperty = (key: string) => (t(key) !== key ? t(key) : null);
  const addresses = JSON.parse(
    getProperty('CFG_COBRAND_ADDRESSES') || '[]'
  ) as Address[];
  const tenantData = {
    logo: tenantInfo?.logo ?? '',
    name: tenantInfo?.name ?? '',
    userType: 'Organization',
    addresses,
  };

  const accountTabs = [
    {
      label: t('general.information'),
      children: <InformationTab tenant={tenantData} kind="tenant" />,
    },
    {
      label: t('general.users'),
      children: <UsersTab data={[]} />,
    },
    {
      label: t('general.legal'),
      children: <LegalTab />,
    },
    ...(isSuperAdmin
      ? [
          {
            label: 'iWarranty Admin',
            children: <IWarrantyAdmin isSuperAdmin={isSuperAdmin} />,
          },
        ]
      : []),
  ];

  return (
    <div className="px-2">
      <div className="pb-4">
        <TabsGeneric items={accountTabs} hugTabs={true} />
      </div>
    </div>
  );
}

export default MyOrgnizationView;
